import type { Confinement, Extradition, Jail } from './index.h'

import {
  app,
  appearance,
  appearanceStyles,
  expired,
  geoblock,
  guest,
  hallway,
  hallway2guest,
  hallway2profiles,
  hallway2trueid,
  lobby,
  profiles,
  sign,
  toa,
} from './cages'

const on = (...x: Extradition): Extradition => [...x]
const cage = (...x: Confinement): Confinement => [...x]

export const jail: Jail = [
  // initial bootstrap cage
  cage(lobby, [
    on(lobby.out.preparationsReady, () => hallway), //
  ]),

  // main guiding cage
  cage(hallway, [
    on(hallway.out.activeGuestSession, () => appearance),
    on(hallway.out.activeSubscriberSession, () => hallway2profiles),
    on(hallway.out.shouldAcceptToa, () => appearanceStyles),
    on(hallway.out.shouldBuySubscription, () => expired),
    on(hallway.out.shouldSignInByTrueid, () => hallway2trueid),
    on(hallway.out.shouldSignInAsGuest, () => hallway2guest),
    on(hallway.out.shouldSignIn, () => sign),
  ]),

  // intermediate guiding to guest cage
  cage(hallway2guest, [
    on(hallway2guest.out.signedInAsGuest, () => appearance),
    on(hallway2guest.out.failedToSignInAsGuest, () => sign),
  ]),

  // intermediate guiding to profiles cage
  cage(hallway2profiles, [
    on(hallway2profiles.out.singleActiveProfile, () => appearance),
    on(hallway2profiles.out.selectedActiveProfile, () => appearance),
    on(hallway2profiles.out.shouldCreateProfile, () => appearanceStyles),
    on(hallway2profiles.out.shouldChooseProfile, () => appearanceStyles),
    on(hallway2profiles.out.shouldManuallyEditActiveProfile, () => profiles),
  ]),

  // intermediate guiding to trueid cage
  cage(hallway2trueid, [
    on(hallway2trueid.out.shouldSignInByTrueId, () => sign),
    on(hallway2trueid.out.failedToSignInByTrueId, () => sign),
  ]),

  // appearance cage, loads appearance customization
  cage(appearance, [
    on(appearance.out.gotoApp, () => app),
    on(appearance.out.gotoGuest, () => guest),
  ]),

  // appearance styles cage, loads appearance styles
  cage(appearanceStyles, [
    on(appearanceStyles.out.gotoToa, () => toa),
    on(appearanceStyles.out.gotoProfiles, () => profiles),
  ]),

  // app cage, all main app routes located here
  cage(app, [
    on(app.out.chooseProfileApp, () => appearance), //
  ]),

  // guest cage, all guest routes located here (= all app routes + sign routes)
  cage(guest, [
    on(guest.out.subscriberSignedIn, () => hallway), //
  ]),

  // geoblock cage
  cage(geoblock, []),

  // cage to choose profile
  cage(profiles, [
    on(profiles.out.chooseProfile, () => appearance), //
  ]),

  // cage to sign in and sign up
  cage(sign, []),

  // cage to accept terms of agreement
  cage(toa, [
    on(toa.out.toaAccepted, () => hallway2profiles), //
  ]),

  // cage to handle expired subscription
  cage(expired, []),
]
